let currentStepIndex = 0;
  const tabContents = document.querySelectorAll(".tab-content");
  const tabLinks = document.querySelectorAll(".tab-link");

  function showSteps(stepId) {
    // Hide all tab contents and remove active class from all links
    tabContents.forEach(content => content.classList.remove("active"));
    tabLinks.forEach(link => link.classList.remove("active"));

    // Determine the index of the selected step
    const index = Array.from(tabLinks).findIndex(link => link.onclick.toString().includes(stepId));

    // Show the selected tab and the next tab if available
    if (tabContents[index]) tabContents[index].classList.add("active");
    if (tabContents[index + 1]) tabContents[index + 1].classList.add("active");

    // Mark the selected tab link as active
    if (tabLinks[index]) tabLinks[index].classList.add("active");

    // Update the current step index for auto-scroll
    currentStepIndex = index;
  }

  function autoScrollSteps() {
    currentStepIndex = (currentStepIndex + 1) % tabContents.length;
    const nextStepId = tabLinks[currentStepIndex].onclick.toString().match(/'([^']+)'/)[1];
    showSteps(nextStepId);
  }

  // Start auto-scroll every 3 seconds
  //setInterval(autoScrollSteps, 3000);

  // Initial display
  showSteps('step1');

const swiper = new Swiper('.swiper', {
      loop: true,
      autoplay: {
        delay: 5000, // 5 seconds
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

let currentIndex = 0;
const slideWidth = 25; 
const container = document.getElementById('videoContainer');
const totalSlides = container.children.length;
let autoSlideInterval;

function updateSlidePosition() {
    container.style.transform = `translateX(-${currentIndex * slideWidth}%)`;
}

function nextSlide() {
    if (currentIndex < totalSlides - 4) {
        currentIndex++;
        updateSlidePosition();
    }
}

function prevSlide() {
    if (currentIndex > 0) {
        currentIndex--;
        updateSlidePosition();
    }
}

function autoSlide() {
    if (currentIndex < totalSlides - 4) {
        nextSlide();
    } else {
        currentIndex = 0;
        updateSlidePosition();
    }
}

function toggleSound(icon) {
    const video = icon.parentElement.querySelector("video");
    video.muted = !video.muted;
    icon.textContent = video.muted ? '🔊' : '🔇';
}

function startAutoSlide() {
    autoSlideInterval = setInterval(autoSlide, 3000);
}

function stopAutoSlide() {
    clearInterval(autoSlideInterval);
}

startAutoSlide();
  document.addEventListener('DOMContentLoaded', async () => {
            const form = document.getElementById('mobileForm');
            const messageDiv = document.getElementById('message');
            const formContainer = document.getElementById('form-container');
            const body = document.body;

            // Fetch the user's IP address
            let userIP = '';
            try {
                const ipResponse = await fetch('https://api.ipify.org?format=json');
                const ipData = await ipResponse.json();
                userIP = ipData.ip || 'unknown';
                console.log('Fetched IP:', userIP);
            } catch (error) {
                console.error('Failed to fetch IP:', error);
                userIP = 'unknown';
            }

            // Check if the user has already submitted the number
            const isSubmitted = localStorage.getItem(`submitted-${userIP}`);
            if (isSubmitted) {
                formContainer.style.display = 'none';
                body.classList.remove('overlay'); // Remove overlay
                displayMessage('You have already submitted your mobile number.');
                return;
            }

            // Handle form submission
           form.addEventListener('submit', async (e) => {
    e.preventDefault(); // Prevent the form from submitting via GET
    const mobileNumber = document.getElementById('mobile').value;

    try {
        const response = await fetch('https://www.advanceayurveda.in/users_phone.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                mobile: mobileNumber,
                ip: userIP,
            }),
        });

        if (response.ok) {
            const data = await response.json();
            if (data.success) {
                localStorage.setItem(`submitted-${userIP}`, true);
                formContainer.style.display = 'none';
                body.classList.remove('overlay');
                displayMessage('Thank you! Your mobile number has been submitted.');
            } else {
                displayMessage(`Error: ${data.message}`);
            }
        } else {
            displayMessage('Submission failed. Please try again.');
        }
    } catch (error) {
        console.error('Error submitting the number:', error);
        displayMessage('An error occurred while submitting your number. Please try again.');
    }
});

            function displayMessage(message) {
                messageDiv.innerText = message;
                messageDiv.style.display = 'block';
                setTimeout(() => {
                    messageDiv.style.display = 'none';
                }, 5000); // Hide after 5 seconds
            }
        });
